import { API } from "../../Services";

export const trelloList = (id) =>{
    return (dispatch) =>{
        dispatch({
            type:"FETCH_TRELLO_LIST",
        })
    
        API.trelloList(id).then((res)=>{
            console.log(res);
            let data = JSON.parse(JSON.stringify(res)).data
            setTimeout(()=>{
                dispatch({
                    type:"RECEIVE_TRELLO_LIST",
                    payload:data,
                })
            },1000)
        }).catch((err)=>{
            dispatch({
                type:"ERROR_TRELLO_LIST",
            })
        })
    }
}